import { useEffect, useState, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { subscribe } from "../utils/pubsub"
import Spinner from "../ui-elements/Spinner"
import ListOfChecklists from '../checklists/ListOfChecklists'
import Button from '../formfields/Button'
import Card from '../ui-elements/Card'
import YellowAlert from '../ui-elements/YellowAlert'
import CheckPeriod from '../shared-components/CheckPeriod'
import { tab } from '@testing-library/user-event/dist/tab'
import { sortChecklistDataByTimePeriod } from '../checklists/checklist-utils/sortChecklistDataByTimePeriod'
import { getStartAndEndTimestampsForDay } from '../utils/getStartAndEndTimestampsForDay'
import Paginate from '../ui-elements/Paginate'
import CheckPeriodRequiringManagerSignoff from '../shared-components/CheckPeriodRequiringManagerSignoff'
import GreenAlert from '../ui-elements/GreenAlert'

type Props = {
}


function ManagerSignoffDashboard({

}: Props) {

    const {
        tableData,
        userData,
        fridges,
        currentOrganisation,
        switchCurrentOrganisation,
        sendMessageToWebsocket
    } = useContext(GlobalContext)

    const today = new Date()
    const day = today.getDate()
    const month = today.getMonth() + 1
    const year = today.getFullYear()
    const [checkPeriodsForThisPeriod, setCheckPeriodsForThisPeriod] = useState<ObjectStringKeyAnyValue | null>(null)
    const [displayItems, setDisplayItems] = useState<ObjectStringKeyAnyValue>({})
    const arrayStartIndex = displayItems.indexOfFirstItem || 0
    const arrayEndIndex = displayItems.indexOfLastItem || 5
    const arrayToDisplay: any[] = checkPeriodsForThisPeriod ? Object.keys(checkPeriodsForThisPeriod).slice(arrayStartIndex, arrayEndIndex) : []
    const checklistsRequiringManagerSignoff = tableData && tableData['Checklists'] ? Object.keys(tableData['Checklists']).filter(checklistId => tableData['Checklists'][checklistId]['requireManagerSignoff'] === true) : []

    useEffect(() => {
        if (tableData && !checkPeriodsForThisPeriod) {
            fetchData()
        }
        if (tableData && tableData['ChecklistPeriods'] && !checkPeriodsForThisPeriod) {
            filterChecklistPeriods()
        }

    }, [tableData, checkPeriodsForThisPeriod])


    const filterChecklistPeriods = () => {
        const newChecklistPeriodsByDay: ObjectStringKeyAnyValue = {}

        for (const key in tableData['ChecklistPeriods']) {
            const thisCheckPeriod = tableData['ChecklistPeriods'][key]
            if (
                thisCheckPeriod['ChecklistInfo']
                && thisCheckPeriod['ChecklistInfo']['requireManagerSignoff']
                && thisCheckPeriod['Progress']
                && parseInt(`${thisCheckPeriod['Progress']['progress_percentage']}`) === 100
                && !thisCheckPeriod['managerSignoff']
            ) {

                // exclude check periods where staff signoff is required but this hasn't been done yet
                if (
                    (
                        // if no staff signoff is required 
                        !thisCheckPeriod['ChecklistInfo'] ||
                        !thisCheckPeriod['ChecklistInfo']['RequireSignoff']
                    )
                    ||
                    (
                        // if staff signoff is required, but this has been done
                        thisCheckPeriod['ChecklistInfo']
                        && thisCheckPeriod['ChecklistInfo']['RequireSignoff']
                        && thisCheckPeriod['Signoff']
                    )

                ) {
                    newChecklistPeriodsByDay[key] = tableData['ChecklistPeriods'][key]
                }
            }
        }
        setCheckPeriodsForThisPeriod(newChecklistPeriodsByDay)
    }

    const fetchData = () => {
        const payload = JSON.stringify({
            "action": "checklists",
            "subAction": "fetchChecklistInfoByTimePeriod",
            "month": month,
            "year": year,
        })
        // console.log('🎣 fetching...')
        sendMessageToWebsocket(payload)
    }


    if (!checkPeriodsForThisPeriod) {
        return null
    }

    if (checklistsRequiringManagerSignoff.length === 0) {
        // return <p>No checklists require manager signoff</p>
        return null
    }


    return <Card fullwidth={true} id={`results-dashboard`}>
        <div className={`w-full h-full flex flex-col gap-2 justify-between`}>

            <div className={`w-full flex flex-row itrems-center justify-between gap-2`}>
                <h3 className={`text-2xl font-righteous text-brandblue`}>
                    Awaiting signoff
                </h3>
            </div>


            {(checkPeriodsForThisPeriod && Object.keys(checkPeriodsForThisPeriod).length > 0) ?

                <Paginate setDisplayItems={setDisplayItems} itemsPerPage={6} maxPageNumbersToDisplay={5} arrayToPageThrough={Object.keys(checkPeriodsForThisPeriod)}>
                    {arrayToDisplay && arrayToDisplay.map((checkPeriodId, index) => {
                        const thisCheckPeriod = tableData.ChecklistPeriods[checkPeriodId]
                        return <CheckPeriodRequiringManagerSignoff key={index} checkperiodId={thisCheckPeriod.Id} />
                    })}
                </Paginate>
                :
                <GreenAlert>No check periods requiring manager signoff</GreenAlert>
            }

        </div>
    </Card>
}
export default ManagerSignoffDashboard